/**
 * @param {string} vertical - The vertical of the article.
 * @param {boolean} ecommerceEnabled - Whether ecommerce is enabled.
 * @returns {"today"|"shop today"|"select"|null} The brand of the hero byline.
 */
export function getHeroBylineBrand(vertical, ecommerceEnabled) {
  if (vertical === 'today') {
    if (ecommerceEnabled) {
      return 'shop today';
    }
    return 'today';
  }

  if (vertical === 'select') {
    return 'select';
  }
  return null;
}
